import Vue from 'vue'
import Router from 'vue-router'
import {auth} from './mod/auth.route'
import {patientMeal} from './mod/patientMeal.route'
import {reg} from './mod/reg.route'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/m/',
  routes: [
    ...auth,
    ...reg,
    ...patientMeal,
    {path: '*', redirect: '/login'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js